import { render, staticRenderFns } from "./BeneficiaryNominationChart.vue?vue&type=template&id=7f952138&scoped=true"
import script from "./BeneficiaryNominationChart.vue?vue&type=script&lang=ts"
export * from "./BeneficiaryNominationChart.vue?vue&type=script&lang=ts"
import style0 from "./BeneficiaryNominationChart.vue?vue&type=style&index=0&id=7f952138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f952138",
  null
  
)

export default component.exports